import { createMemo } from "solid-js"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { useHoveredTileGraphNodeMemo } from "./useHoveredTileGraphNodeMemo"

// return all river water ents
export const useHoveredPositionElevationMemo = createSharedCachedFactory((engine) => {
  const getHoveredTileGraphNode = useHoveredTileGraphNodeMemo(engine)

  const memo = createMemo(() => {
    const tileGraphNode = getHoveredTileGraphNode()
    if (tileGraphNode) {
      const floor_e_value = tileGraphNode.floor_e()
      const water_e_value = tileGraphNode.water_e()
      return Math.max(floor_e_value, water_e_value)
    }
    return null
  })

  return memo
})
